module.exports = __webpack_public_path__ + "img/reports2.584dcdbf.png";